<template>
  <div>
    <v-dialog
      :value="value"
      :persistent="true"
      width="100%"
    >
      <v-card>
        <v-card-title>
          <div class="title-wrap">
            {{ '위치정보 이용 동의' | translate }}
            <div class="seltbox">
              <select
                v-model="lang"
                class="select__custom"
              >
                <option
                  v-for="(language, index) in languageOptions"
                  :key="language.key"
                  :value="language.key"
                >
                  {{ language.value }}
                </option>
              </select>
              <div class="select__arrow" />
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="statement-detail">
            <div class="statement-detail-txt">
              {{ detailContent[lang] }}
            </div>
          </div>
          <div class="radio-wrap">
            <div>{{ '위치정보 이용' }}</div>
            <v-radio-group
              v-model="locationConsentYn"
              class="caption ma-0 pa-0"
              mandatory
              row
              dense
              :hide-details="true"
            >
              <div class="d-flex justify-start tn_height">
                <v-radio
                  :label="'동의함' | translate"
                  value="Y"
                  color="info"
                />
                <v-radio
                  :label="'동의안함' | translate"
                  value="N"
                  color="info"
                />
              </div>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="btn-wrap">
            <v-btn
              color="second"
              class="mr-2"
              @click.stop="onClickNoShow"
            >
              {{ '7일간 보류' | translate }}
            </v-btn>
            <v-btn
              color="primary"
              @click.stop="onClickSave"
            >
              {{ '저장' | translate }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const NO_SHOW_KEY = 'NO_SHOW_LOCATION_CONSENT'

import {PATH} from "@/constants";

export default {
  name: 'LocationInfoCollection',
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      languageOptions: [
        {key: "ko", value: this.$translate("한국어")},
        {key: "en", value: this.$translate(" 영어")},
        {key: "zh", value: this.$translate("중국어")},
      ],
      detailContent: {
        ko: undefined,
        en: undefined,
        zh: undefined,
      },
      lang: 'en',
      locationConsentYn: 'N',
      context: [],
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.loadPrivacyState()
      }
    }
  },
  mounted() {
    this.initLang()
    this.loadStatements()
    this.loadPrivacyState()
  },
  methods: {
    /**
     * 현재 로그인한 계정의 또는 브라우저가 유효한 언어이면 해당하는 언어로 아니면 'en' 으로 설정
     */
    initLang() {
      const langPart = this.$languagePartAuth();

      switch (langPart) {
        case "en":
        case "ko":
        case "zh":
          this.lang = langPart;
          break;
        default:
          this.lang = "en";
          break;
      }
    },

    loadStatements() {
      this.languageOptions.forEach(e => {
        this.$httpClient.get(`/static/TermLocationAgreement-${e.key}.txt`)
          .then((response) => {
            this.detailContent[e.key] = response;
          })
          .catch((e) => {
            console.error(e)
            this.detailContent[e.key] = 'Failed to retrieve information.';
          });
      })
    },

    async loadPrivacyState() {
      try {
        this.context.splice(0, this.context.length)
        const response = await this.$request(PATH.USER.PRIVACY.GET)
          .setObject()
          .catch()
          .enqueue();
        if (!!response && !!response.data && response.data.length > 0) {
          this.context.push(...response.data)
          this.locationConsentYn = this.context[0].locationConsentYn
        }
        this.checkShowDialog()
      } catch (e) {
        console.error(e)
      }
    },

    checkShowDialog() {
      try {
        if (!this.context || this.context.length <= 0){
          // 위취정보 동의 설정한 적 없음

          const loadData = localStorage.getItem(NO_SHOW_KEY)

          if (!loadData || loadData === '') {
            // 7일간 보기 버튼 누른 적 없음
            this.openChangeValue(true)

          } else {
            // 7일간 보기 버튼 누른 적 있음
            const noShowLocationConsent = this.$parseDate(loadData).plus({ days: 7 })
            if (noShowLocationConsent.diffNow().toObject().milliseconds < 0) {
              // 7일 경과 함
              this.openChangeValue(true)
            }
          }
        } else {
          // 위취정보 동의 설정한 적 있음
          const lastData = this.context[0]
          const lastDatetime = this.$parseDate(lastData.regDatetime).plus({ days: 30 })

          if (lastData.locationConsentYn !== 'Y' && lastDatetime.diffNow().toObject().milliseconds < 0) {
            // 동의 하지 않고 30일 경과
            const loadData = localStorage.getItem(NO_SHOW_KEY)
            if (!loadData || loadData === '') {
              // 7일간 보기 버튼 누른 적 없음
              this.openChangeValue(true)
            } else {
              // 7일간 보기 버튼 누른 적 있음
              const noShowLocationConsent = this.$parseDate(loadData).plus({ days: 7 })
              if (noShowLocationConsent.diffNow().toObject().milliseconds < 0) {
                // 7일 경과 함
                this.openChangeValue(true)
              }
            }
          }
        }
      } catch (e) {
        console.error(e)
      }
    },

    onClickNoShow() {
      localStorage.setItem(NO_SHOW_KEY, this.$now().toISO())
      this.openChangeValue(false)
    },
    async onClickSave() {
      try {
        const response = await this.$request(PATH.USER.PRIVACY.INSERT)
          .setObject(this.locationConsentYn)
          .catch()
          .enqueue();
        if (!!response) {
          this.$snackbarSuccess(`${this.locationConsentYn === 'Y' ? '동의함' : '동의안함' } 처리되었습니다.\n${this.$parseDate(response).toFormat('yyyy-MM-dd HH:mm')}`, 3000);
        }
        await this.loadPrivacyState()
        this.openChangeValue(false)
      } catch (e) {
        console.error(e)
      }
    },

    openChangeValue(value) {
      this.$emit('input', value)
    },
  },
}
</script>


<style scoped>
.title-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seltbox {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 8px;
}
.seltbox div {
  white-space: nowrap;
}
.seltbox select {
  height: 32px;
  line-height: 32px;
  border: 1px solid #ddd;
  width: 80px;
  padding: 0 6px;
  font-size: 0.875rem;
  letter-spacing: -0.5px;
}
.seltbox .select__arrow {
  top: 20px;
}
.radio-wrap {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
}
.radio-wrap >>> .v-radio .v-label{
  font-size: 12px !important;
}
.statement-detail {
  min-height: 250px;
  height: calc(100vh - 280px);
  text-align: left;
  overflow-y: auto;
  border: 1px solid #eeeeee;
  margin-bottom: 4px;
}
.statement-detail .statement-detail-txt {
  font-size: 0.8125rem;
  color: #202020;
  padding: 10px;
  white-space: pre-line;
  line-height: 24px;
}
.btn-wrap {
  width: 100%;
  display: flex;
  justify-content: end;
}
</style>